import { componentsReady } from '@porsche-design-system/components-react';
import { borderRadiusSmall, borderRadiusMedium } from '@porsche-design-system/components-react/styles';
import { useEffect } from 'react';

const carouselCss = (borderSize: 'small' | 'medium') => `
    :host {
        --p-carousel-prev-next-filter: invert(1);
        --p-carousel-border-radius: ${borderSize === 'small' ? borderRadiusSmall : borderRadiusMedium};
    }

    :host .splide__track {
        padding: 0 !important;
    }

    :host .header {
        display: none;
    }

    :host .splide__slide {
        margin-right: clamp(4px, 0.25vw + 3px, 8px) !important;
    }
`;

const useCarouselStyle = (containerRef: React.RefObject<HTMLDivElement>, borderSize: 'small' | 'medium' = 'small') => {
    useEffect(() => {
        if (!containerRef.current) {
            return;
        }

        const container = containerRef.current;

        componentsReady(container).then(() => {
            const carousel = container.querySelector<HTMLDivElement>('p-carousel');
            const style = document.createElement('style');
            style.textContent = carouselCss(borderSize);
            carousel?.shadowRoot?.appendChild(style);
        });
    }, [containerRef, borderSize]);
};

export default useCarouselStyle;
